(function () {
  "use strict";

  var YOUTUBE_CONSENT_GROUP = 'C0004';

  function activeGroupsInclude(group) {
    if (typeof window.OnetrustActiveGroups !== 'string') return false;
    return window.OnetrustActiveGroups.split(',').filter(Boolean).indexOf(group) !== -1;
  }

  function isBannerAnswered() {
    var banner = document.getElementById('onetrust-banner-sdk');
    if (!banner) return true;

    return getComputedStyle(banner).display === 'none';
  }

  function hasAcceptedYouTubeCookies() {
    if (window.__consentVendorGate && typeof window.__consentVendorGate.isAllowed === 'function') {
      if (window.__consentVendorGate.isAllowed('youtube')) return true;
    }

    // The persisted cookie is the source of truth for the user's actual choice.
    // Check it first: window.OnetrustActiveGroups can briefly be an empty string
    // placeholder while the OneTrust script is still resolving consent, and relying
    // on it first would report "not accepted" even after a real previous acceptance.
    var match = document.cookie.match(/(?:^|; )OptanonConsent=([^;]*)/);
    if (match) {
      var cookie;
      try {
        cookie = decodeURIComponent(match[1]);
      } catch (error) {
        cookie = match[1];
      }

      // interactionCount=0 means the banner defaults haven't been confirmed by a real user action yet;
      // some OneTrust setups pre-populate groups as granted by default, so that snapshot can't be trusted
      var interactionMatch = cookie.match(/interactionCount=(\d+)/);
      var interactionCount = interactionMatch ? parseInt(interactionMatch[1], 10) : 0;
      if (interactionCount) {
        var groupsMatch = cookie.match(/groups=([^&]*)/);
        if (groupsMatch && new RegExp('(^|,)' + YOUTUBE_CONSENT_GROUP + ':1(,|$)').test(groupsMatch[1])) {
          return true;
        }
      }
    }

    if (typeof window.OnetrustActiveGroups === 'string') {
      return isBannerAnswered() && activeGroupsInclude(YOUTUBE_CONSENT_GROUP);
    }

    return false;
  }

  function buildEmbedSrc(container) {
    var videoId = container.getAttribute('data-youtube-id');
    if (videoId) {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?enablejsapi=1&rel=0&autoplay=0';
    }

    return container.getAttribute('data-embed-src');
  }

  function acceptYouTubeCookies(callback) {
    if (hasAcceptedYouTubeCookies()) {
      callback();
      return;
    }

    if (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.UpdateConsent === 'function') {
      try {
        window.OneTrust.UpdateConsent('Category', YOUTUBE_CONSENT_GROUP + ':1');
      } catch (error) {
        if (typeof window.OneTrust.ToggleInfoDisplay === 'function') window.OneTrust.ToggleInfoDisplay();
        return;
      }

      // Don't dispatch a synthetic OneTrustGroupsUpdated event here: OneTrust writes the
      // cookie asynchronously, and firing it early races with the real event and makes
      // the "OneTrustGroupsUpdated" listener below reset the container before it loads.
      // Poll until the real cookie/group update lands, then load; load anyway after the
      // timeout since the user already explicitly opted in by clicking.
      var attempts = 0;
      var maxAttempts = 10;
      (function waitForConsent() {
        if (hasAcceptedYouTubeCookies()) {
          callback();
          return;
        }

        attempts += 1;
        if (attempts < maxAttempts) {
          window.setTimeout(waitForConsent, 300);
          return;
        }

        callback();
      })();
      return;
    }

    if (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
    }
  }

  function injectIframe(container) {
    if (!container || container.getAttribute('data-loaded') === 'true') return;

    var src = buildEmbedSrc(container);
    if (!src) return;

    container.setAttribute('data-loaded', 'true');

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = container.getAttribute('data-title') || 'YouTube video';
    iframe.frameBorder = '0';
    iframe.allow = container.getAttribute('data-allow') || '';
    iframe.allowFullscreen = true;
    iframe.className = container.getAttribute('data-iframe-class') || 'w-full h-full';

    var slideContainer = container.closest('.swiper-slide');
    var loader = slideContainer ? slideContainer.querySelector('.loader') : container.querySelector('.loader');
    if (loader) {
      loader.style.display = 'block';
      iframe.addEventListener('load', function () {
        loader.style.display = 'none';
      });
    }

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = 'none';

    container.appendChild(iframe);
    container.dispatchEvent(new CustomEvent('youtube-click-to-load:loaded', { bubbles: true, detail: { iframe: iframe } }));
  }

  function resetContainer(container) {
    var iframe = container.querySelector('iframe');
    if (iframe) iframe.remove();
    container.setAttribute('data-loaded', 'false');

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = '';

    var loader = container.querySelector('.loader');
    if (loader) loader.style.display = 'none';
  }

  function loadAfterConsentSettles(container) {
    var attempts = 0;
    var maxAttempts = 10;

    (function check() {
      if (hasAcceptedYouTubeCookies()) {
        injectIframe(container);
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) window.setTimeout(check, 500);
    })();
  }

  function initContainer(container) {
    if (container.getAttribute('data-initialized') === 'true') return;
    container.setAttribute('data-initialized', 'true');

    loadAfterConsentSettles(container);

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) {
      playButton.addEventListener('click', function () {
        acceptYouTubeCookies(function () { injectIframe(container); });
      });
    }

    // Stay on the placeholder until the user accepts YouTube cookies, then auto-load.
    window.addEventListener('OneTrustGroupsUpdated', function onConsentUpdate() {
      if (hasAcceptedYouTubeCookies()) {
        injectIframe(container);
        return;
      }

      resetContainer(container);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-youtube-click-to-load]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support embeds added after initial load (e.g. swiper slides rendered dynamically)
  document.addEventListener('youtube-click-to-load:refresh', initAll);
})();
